
import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { CategoriesService } from '../categories/categories.service';
import { VenuesService } from '../venues/venues.service';
import { SettingsService } from '../settings/settings.service';
@Injectable({
  providedIn: 'root',
})
export class AppLoaderService {
  constructor(
    private apiSrv: ApiService,
    private categoriesService: CategoriesService,
    private venuesService: VenuesService,
    private settingsService : SettingsService
   
  ) {}


  async getCategories() {
    await this.categoriesService.getCategories();
  }

  async getVenuesList() {
    await this.venuesService.getVenues();
  }

  async getMainAppSettings(){
    await this.settingsService.updateMainAppSettings();
  }

 
}
